export default [
  {
    path: '/orders/SearchHistory',
    name: 'orders-search-history',
    props: true,
    component: () => import('@/views/orders/SearchHistory.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Rechercher un Colis',
      breadcrumb: [
        {
          text: 'Rechercher un Colis',
          to: { name: 'orders-search-history' },
        },
        {
          text: 'Rechercher un Colis',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'supplier'],
    },
  },
]
